import React from 'react';
import { AclAccess, IAcl } from '../../../../types/interfaces/acl';
import { useAddPermissionComponent } from './useAddPermissionComponent';
import { Box, Grid } from '@mui/material';
import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddPermission.styles';
import theme from '../../../../styles/theme';
// TODO: Replace with proper permission list from backend or remove if not needed

interface IAddPermissionProps {
  aclItem: IAcl;
  onClose: () => void;
}

export default function AddPermission(props: IAddPermissionProps) {
  const { aclItem, onClose } = props;
  const { t } = useTranslation();
  const { formik, roles, isLoading, adminUsers } = useAddPermissionComponent(
    onClose,
    aclItem,
  );
  const { classes } = useStyles(theme);
  const accessOptions = [
    { id: AclAccess.ALLOW, name: t(`superAdminDashboard.${AclAccess.ALLOW}`) },
    { id: AclAccess.DENY, name: t(`superAdminDashboard.${AclAccess.DENY}`) },
  ];
  // TODO: Get permissions list from backend or define here if needed for ACL creation
  const permissions: { id: string; name: string }[] = [];

  const adminUserOptions = adminUsers?.map((user) => ({
    ...user,
    name: user.firstname + ' ' + user.lastname,
  }));

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.role')}
              name="role"
              options={roles}
              defaultValue={roles?.find((r) => r.id === formik.values.role?.id)}
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.user')}
              name="user"
              options={adminUserOptions}
              defaultValue={adminUserOptions?.find(
                (r) => r.id === formik.values.user?.id,
              )}
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.permission')}
              name="permission"
              options={permissions}
              disableClear
              defaultValue={permissions?.find(
                (r) => r.id === formik.values.permission,
              )}
              onChange={(e) =>
                formik.setFieldValue('permission', e.target.value.id)
              }
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.access')}
              name="access"
              disableClear
              showSearch={false}
              options={accessOptions}
              defaultValue={accessOptions?.find(
                (r) => r.id === formik.values.access,
              )}
              onChange={(e) =>
                formik.setFieldValue('access', e.target.value.id)
              }
              formik={formik}></AppFormSelectWrapper>
          </Grid>
        </Grid>
        <Box className={classes.addPermissionButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {aclItem ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
